import { useAuthStore } from "@/stores/auth";
import { geniFetch } from "./geniBackend";

export type UiTheme = "light" | "dark";

export const saveThemePreference = async (theme: UiTheme) => {
  const authStore = useAuthStore();
  if (!authStore.cardGeniusAccountProfile?.profileId) throw new Error("CardGenius account profile not found");
  await geniFetch("/account/profile", {
    method: "PATCH",
    body: JSON.stringify({ theme }),
  });
};

